import React from 'react'
import { LockIcon } from 'lucide-react'

import { cn } from '@/shared/lib/utils'

export function BasicLockField({ value }: { value: boolean }) {
	return (
		<div className='flex w-full items-center'>
			<LockIcon
				className={cn(
					'size-3',
					value
						? 'text-muted-foreground'
						: 'text-accent-5 invisible group-hover:visible'
				)}
			/>
		</div>
	)
}
